__turbopack_context__.v({
  "link": "tsGgTG_link",
  "root": "tsGgTG_root",
});
